import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { toYearMonth } from "../../deepViewDates";

const sectionLabelSx = {
  fontSize: "11px",
  fontWeight: 500,
  color: "#00000099",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const MonthlyContext = () => {
  const period = useSelector(
    (state: any) => state?.deepView?.deepViewData?.period,
  );

  const yearMonth = toYearMonth(period?.fmt_offset_activity_month_year);

  const metricRows = [
    {
      metric: "sum(cpa_income)",
      value: period?.fmt_month_sum_cpa_usd,
      valueColor: "#7B1FA2",
    },
    {
      metric: "sum(revshare_income)",
      value: period?.fmt_month_sum_revshare_usd,
    },
    { metric: "sum(total_income)", value: period?.fmt_month_sum_total_usd },
  ];

  // The carried-forward row is named after the policy in force
  const policyLabel =
    period?.offset_type === "fenced_cpa" ? "Fenced CPA" : "NCO";

  return (
    <Box mt={1.5}>
      <Typography sx={{ ...sectionLabelSx, mb: 0.5 }}>
        Monthly context {yearMonth && `— ${yearMonth}`}
      </Typography>

      <Stack
        direction="row"
        sx={{ borderBottom: "1px solid #E0E0E0", py: 0.5, px: 1 }}
      >
        <Typography sx={{ ...sectionLabelSx, flexGrow: 1 }}>Metric</Typography>
        <Typography sx={{ ...sectionLabelSx, textAlign: "right" }}>
          Monthly sum (USD)
        </Typography>
      </Stack>

      {metricRows.map((row) => (
        <Stack
          key={row.metric}
          direction="row"
          alignItems="center"
          sx={{
            py: 0.75,
            px: 1,
            borderBottom: "1px solid #F0F0F0",
          }}
        >
          <Typography
            sx={{
              flexGrow: 1,
              textAlign: "right",
              pr: 2,
              fontSize: "13px",
              color: "#000000DE",
            }}
          >
            {row.metric}
          </Typography>
          <Typography
            sx={{
              fontSize: "13px",
              color: row.valueColor ?? "#000000DE",
              whiteSpace: "nowrap",
            }}
          >
            {row.value ?? "-"}
          </Typography>
        </Stack>
      ))}

      <Stack
        direction="row"
        alignItems="center"
        sx={{
          py: 0.75,
          px: 1,
          backgroundColor: "#FAFAFA",
          borderBottom: "1px solid #F0F0F0",
        }}
      >
        <Typography
          sx={{
            flexGrow: 1,
            textAlign: "right",
            pr: 2,
            fontSize: "13px",
            fontWeight: 700,
            color: "#000000DE",
          }}
        >
          {policyLabel}: sum(total_income) carried forward
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 700,
            color: "#000000DE",
            whiteSpace: "nowrap",
          }}
        >
          = {period?.fmt_month_sum_total_usd ?? "-"}
        </Typography>
      </Stack>
    </Box>
  );
};

export default MonthlyContext;
